import { render, staticRenderFns } from "./public-customer.vue?vue&type=template&id=e5e185a8&scoped=true"
import script from "./public-customer.vue?vue&type=script&lang=js"
export * from "./public-customer.vue?vue&type=script&lang=js"
import style0 from "./public-customer.vue?vue&type=style&index=0&id=e5e185a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5e185a8",
  null
  
)

export default component.exports